import React from 'react';
import headerLogo from '../../assets/branding/Header_logo.png';

const TopNav = ({ onSignIn, onSignUp }) => {
    const scrollToFeatures = () => {
        const el = document.getElementById('features');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <nav className="lp-topnav" role="navigation" aria-label="Landing navigation">
            <div className="lp-topnav-inner">
                {/* Logo */}
                <a href="/" className="lp-brand-lockup" aria-label="Finlytics Forge home">
                    <img
                        src={headerLogo}
                        alt="Finlytics Forge"
                        className="landing-brand-logo"
                    />
                    <span className="lp-brand-text">
                        <span className="lp-brand-title">Finlytics</span>
                        <span className="lp-brand-subtitle">Forge</span>
                    </span>
                </a>

                {/* Right links */}
                <div className="lp-nav-links">
                    <button className="lp-nav-link" onClick={scrollToFeatures} type="button">
                        Features
                    </button>
                    <button className="lp-nav-link" type="button" disabled style={{ opacity: 0.5 }}>
                        Pricing
                    </button>
                    <button className="lp-nav-signup" onClick={onSignUp} type="button">
                        Sign Up
                    </button>
                    <button className="lp-nav-signin" onClick={onSignIn} type="button">
                        Sign In
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default TopNav;
